/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from "react";
import { useRecoilState } from "recoil";

import AccessControl from "../functional/AccessControl";

import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import notificationState from "../../states/notificationState";

import getSchema from "../../lib/api/getSchema";

import { debounce } from "lodash";

import { Selector } from '@grapecity/wijmo.grid.selector';

import TkAgreementManagementExelUploadButton from "../input/TkAgreementManagementExelUploadButton";
import TkTotalAmountCalculationAgreeButton from '../input/TkTotalAmountCalculationAgreeButton';
import TkTotalAmounCalculationconfirmCostUpdateRecordButton from './../input/TkTotalAmounCalculationconfirmCostUpdateRecordButton';

function TkAgreementManagement(props) {

    const id = "TkAgreementManagement";
    const table = "TkAgreementManagement";
    const view = "TkVwAgreementManagement";

    const [tableSchema, setTableSchema] = useState();
    const [lengthEdit, setLengthEdit] = useState(false);
    const [agreeEdit, setAgreeEdit] = useState(false);

    const [grid, setGrid] = useState();
    const [api, setApi] = useState();

    const [isEmpty, setIsEmpty] = useState();

    const [onSelectMst, setOnSelectMst] = useState();

    // const [date,] = useState(new Date());

    // const [from, setFrom] = useState();

    // const [to, setTo] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    const [, setSelector] = useState();

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("TkAgreementManagement");

            if (mounted) {

                setTableSchema(schema);

            }

        })();

        return (() => {

            mounted = false;

        });

    }, []);


    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        // setOnSelectMst(grid.selectedItems[0]);
                        setOnSelectMst(grid.selectedItems);

                    }
                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        // setOnSelectMst(grid.selectedItems[0]);
                        setOnSelectMst(grid.selectedItems);
                    }
                }), 10);

                grid.formatItem.addHandler(function (s, e) {
                    if (e.panel === s.cells) {
                        let col = s.columns[e.col];

                        if (col.binding === 'totalCost') {

                            if (!s.rows[e.row].dataItem["agreementFlag"]) {

                                e.cell.style.color = 'red';
                            }


                        }
                    }
                });

            }
        })();

    }, [grid]);


    const orderBuyerDetailIdList = useMemo(() => {
        let detailIdList = [];
        if (onSelectMst) {

            for (let item of onSelectMst) {
                detailIdList.push(item.orderBuyerDetailId)
            }
        }
        return detailIdList;
    }, [onSelectMst]);

    useEffect(() => {

        if (onSelectMst) {

            if (onSelectMst[0]?.agreementState?.toString()) {
                setAgreeEdit(false);
            } else {
                setAgreeEdit(true);
            }

            if (onSelectMst.length !== 1) {
                setLengthEdit(true);
            } else {
                setLengthEdit(false);
            }

        }
    }, [onSelectMst]);

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const onInitialized = (grid) => {
        grid.headersVisibility = "All";
        setSelector(new Selector(grid));
        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {

        if (api) {
            api.refresh();
        }

        notifySuccess(msg);
    };


    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const onAppendButtonInFrontOfSearch = () => {
        return (
            <>
                <BasicCrudScreenActionItemLayout>
                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkAgreementManagementExelUploadButton
                            id={"TkAgreementManagement"}
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            // disabled={onSelectMst?.approvalState ? true : false || isEmpty}55
                            onSuccess={onSuccess}
                        />
                    </AccessControl>
                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod={tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")}>
                        <TkTotalAmounCalculationconfirmCostUpdateRecordButton
                            id={id}
                            grid={grid}
                            refresh={api}
                            disabled={isEmpty || lengthEdit || agreeEdit}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>
                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkTotalAmountCalculationAgreeButton
                            id={"TkTotalAmountCalculation"}
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            disabled={isEmpty || lengthEdit || agreeEdit}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            agreementState={onSelectMst && onSelectMst[0]?.agreementState ? 'disagree' : 'agree'}
                            detailList={orderBuyerDetailIdList}
                        />
                    </AccessControl>
                    {/* <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkTotalAmountCalculationEMButton
                            id={"TkAgreementManagement"}
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            disabled={onSelectMst?.approvalState ? true : false || isEmpty}
                            onSuccess={onSuccess}
                            agreeIdList={agreeIdList}
                        />
                    </AccessControl> */}
                </BasicCrudScreenActionItemLayout>
            </>
        );
    };

    // const onDateRangeChanged = (from, to) => {
    //     setFrom(from);
    //     setTo(to);

    // }

    // const toMonth = useMemo(() => {
    //     return new Date(date.getFullYear(), date.getMonth());
    // }, [])

    // const fromMonth = useMemo(() => {
    //     return new Date(date.getFullYear(), date.getMonth() - 1);
    // }, [])


    // const query = useMemo(() => {
    //     return { $from: from, $to: to }
    // }, [from, to])

    return (
        <BasicCrudScreenType
            id={id}
            table={table}
            view={view}
            // $queries={query}
            // headerTitle={t("term.cost")}
            noCreate
            noEdit
            noDelete
            noExcel
            // onAppendHeaderAtFirst={() =>
            //     <>
            //         <YearMonthDateRangeSelector onChange={onDateRangeChanged}
            //             initFrom={fromMonth} initTo={toMonth}
            //         />
            //     </>
            // }
            onLoadData={onLoadData}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
            exportFormatItem={() => { }}
        />
    );
}

export default TkAgreementManagement;
